import RepayEarlyForFree from '../../OutstandingView/dashboardActions/RepayEarlyForFree/RepayEarlyForFree';
import FutureRepayments from '../../dashboardComponents/futureRepayment/FutureRepayments';
import PastRepayments from '../../dashboardComponents/pastRepayments/PastRepayments';
import styles from './RepaymentsPanel.module.css';

export const RepaymentsPanel = ({
    accountId,
    isOverdue = false
}: {
    accountId: string;
    isOverdue?: boolean;
}) => {
    return (
        <>
            <FutureRepayments
                className={styles.dashboardAction}
                accountId={accountId}
            />

            <PastRepayments
                className={styles.dashboardAction}
                accountId={accountId}
            />

            {!isOverdue && (
                <RepayEarlyForFree className={styles.dashboardAction} />
            )}
        </>
    );
};
